/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Device Package - Workstation (@accedo/xdk-device-workstation) 4.1.1
* 
*******************************************************************************/
import{klass,AbstractDevicePackage,StorageManager,DeviceExtensionManager}from"@accedo/xdk-core";import System from"./System";const DevicePackage=klass.create(AbstractDevicePackage,{},{async setup(){this._storageManager=StorageManager.singleton(),this._extensionManager=DeviceExtensionManager.singleton(),this._system=new System}});export default DevicePackage;